export class BusinessRules {
  identifier: string = "";
  name: string = "";
  title: string = "";

  constructor(init?: Partial<BusinessRules>) {
    Object.assign(this, init);
  }

  static parse(data: any): BusinessRules {
    return new BusinessRules({
      identifier: data.identifier ?? "",
      name: data.name ?? "",
      title: data.title ?? "",
    });
  }
}
